import React, { Component } from 'react';
import SelectorModel from "./SelectorModel";

export default class SelectorLock extends Component {

    state = {
        model: new SelectorModel({})
    };

    constructor(props, context) {
        super(props, context);
    }

    componentWillMount() {

    }

    componentWillUnmount() {

    }

    render() {

        return (
            <div className={"selector-ui selector-lock"} style={this.state.model.toStyle()} >
            </div>
        );
    }
}
